class FormatterService {
  numberFormatter = Intl.NumberFormat
  currencyFormatter = Intl.NumberFormat

  constructor () {
    const culture = 'en-CA'
    this.numberFormatter = new Intl.NumberFormat(culture, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
    this.currencyFormatter = new Intl.NumberFormat(culture, {
      currency: 'CAD',
      style: 'currency',
      minimumFractionDigits: 2
    })
  }

  updateFormatLocale (value) {
    const locale = `${value}-CA`
    this.numberFormatter = new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
    this.currencyFormatter = new Intl.NumberFormat(locale, {
      currency: 'CAD',
      style: 'currency',
      minimumFractionDigits: 2
    })
    this.unitsNumberFormatter = new Intl.NumberFormat(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 10
    })
  }

  formatNumber (value) {
    return this.numberFormatter.format(value)
  }

  formatUnitsNumber (value) {
    return this.unitsNumberFormatter.format(value)
  }

  formatSeparator (value, fragtions = 0) {
    if (!value || value.toFixed === undefined) {
      return value
    }
    return value.toFixed(fragtions).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  formatMoney (value) {
    return this.currencyFormatter.format(value)
  }

  toLocaleString (date, format) {
    const d = new Date(date)
    return d.toLocaleString(undefined, format)
  }
}

export default new FormatterService()
